<template>
  <v-layout row>
    <v-flex xs12 sm6 md12 v-if="lead">
      <v-card v-if="Number(average) <= 180">
        <v-list two-line>
          <v-list-tile>
            <v-list-tile-action>
              <v-icon color="red">error</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-sub-title class="red--text"
                >Média de consumo não informada ou muito
                baixa</v-list-tile-sub-title
              >
            </v-list-tile-content>
          </v-list-tile>
        </v-list>
      </v-card>
      <v-card
        color="red darken-2"
        class="red--text"
        v-if="Number(average.value) >= 180"
      >
        <v-list subheader>
          <v-subheader>Sem Enercred</v-subheader>
        </v-list>
        <v-list two-line>
          <v-list-tile>
            <v-list-tile-action>
              <v-icon color="red">business</v-icon>
            </v-list-tile-action>

            <v-list-tile-content>
              <v-list-tile-sub-title class="red--text"
                >Paga para a CEMIG</v-list-tile-sub-title
              >
              <!-- <v-list-tile-title>{{average | formatarMoeda}}</v-list-tile-title> -->
            </v-list-tile-content>

            <v-list-tile-action class="red--text">
              {{ average.value | formatarMoeda }}
            </v-list-tile-action>
          </v-list-tile>
        </v-list>
      </v-card>
      <br />
      <!-- <v-card v-if="lead.name"> -->
      <v-card color="primary darken-2" v-if="Number(average.value) > 180">
        <v-list subheader>
          <v-subheader>Com enercred</v-subheader>
        </v-list>
        <v-list two-line>
          <v-list-tile>
            <v-list-tile-action>
              <v-icon color="teal">wb_sunny</v-icon>
            </v-list-tile-action>

            <v-list-tile-content>
              <v-list-tile-sub-title class="teal--text"
                >Recebe {{ average.creditos | formatarMoeda }} em
                créditos</v-list-tile-sub-title
              >
              <v-list-tile-title>e paga apenas</v-list-tile-title>
            </v-list-tile-content>

            <v-list-tile-action class="teal--text">
              {{ average.pagamento | formatarMoeda }}
            </v-list-tile-action>
          </v-list-tile>

          <v-divider inset></v-divider>

          <v-list-tile>
            <v-list-tile-action>
              <v-icon color="red">business</v-icon>
            </v-list-tile-action>

            <v-list-tile-content>
              <v-list-tile-sub-title class="red--text"
                >Paga para a CEMIG</v-list-tile-sub-title
              >
              <!-- <v-list-tile-title>{{lead.phone}}</v-list-tile-title> -->
            </v-list-tile-content>

            <v-list-tile-action>
              <v-tooltip bottom v-if="tooltip_custo_min">
                <template v-slot:activator="{ on }">
                  <v-icon slot="start" v-on="on">help</v-icon>
                  {{ average.pagamento_cemig | formatarMoeda }}
                </template>
                <span>{{ tooltip_custo_min }}</span>
              </v-tooltip>
            </v-list-tile-action>
          </v-list-tile>

          <v-divider inset></v-divider>

          <v-list-tile>
            <v-list-tile-action>
              <v-icon color="indigo">attach_money</v-icon>
            </v-list-tile-action>

            <v-list-tile-content>
              <v-list-tile-title>Paga menos</v-list-tile-title>
              <v-list-tile-sub-title>Cemig + Enercred</v-list-tile-sub-title>
            </v-list-tile-content>

            <v-list-tile-action class="indigo--text">
              {{
                (average.pagamento + average.pagamento_cemig) | formatarMoeda
              }}
            </v-list-tile-action>
          </v-list-tile>

          <v-divider inset></v-divider>

          <v-list-tile>
            <v-list-tile-action>
              <v-icon color="indigo">outlined_flag</v-icon>
            </v-list-tile-action>

            <v-list-tile-content>
              <v-list-tile-title>Economia</v-list-tile-title>
              <v-list-tile-sub-title
                >Aproximadamente
                {{ average.economia_mensal | formatarMoeda }} por
                mês</v-list-tile-sub-title
              >
            </v-list-tile-content>

            <v-list-tile-action class="indigo--text">
              {{ average.economia_anual | formatarMoeda }}
            </v-list-tile-action>
          </v-list-tile>
          <v-list-tile v-if="this.lead.consumer_unit">
            <v-list-tile-action>
              <v-icon color="grey darken-2">pie_chart</v-icon>
            </v-list-tile-action>

            <v-list-tile-content>
              <v-list-tile-title>% da Usina</v-list-tile-title>
              <v-list-tile-sub-title
                >Percentual de aluguel da usina</v-list-tile-sub-title
              >
            </v-list-tile-content>

            <v-list-tile-action class="grey--text darken-2">
              {{ this.lead.consumer_unit.percentage }}%
            </v-list-tile-action>
          </v-list-tile>
          <!-- <v-divider inset></v-divider>

                    <v-list-tile>
                        <v-list-tile-action>
                            <v-icon color="indigo">event</v-icon>
                        </v-list-tile-action>

                        <v-list-tile-content>
                            <v-list-tile-sub-title>Assinou contrato em</v-list-tile-sub-title>
                            <v-list-tile-title>{{lead.signedcontract_at | formatDate}}</v-list-tile-title>
                        </v-list-tile-content>
                    </v-list-tile> -->
        </v-list>
      </v-card>
    </v-flex>
  </v-layout>
</template>
<script>
import { eventBus } from "../../main";
import moment from "moment";
import { calcconsumerunit } from "../../services/calcCreditos";
export default {
  data: function () {
    return {
      lead: {},
      tooltip_custo_min:
        "As normas brasileiras de energia obrigam que você pague um valor mínimo para a concessionária.",
    };
  },
  mounted() {
    eventBus.$on("Lead", (lead) => {
      this.lead = lead;
    });
  },
  computed: {
    average() {
      if (this.lead.consumer_unit && this.lead.consumer_unit.history) {
        const calc = calcconsumerunit(this.lead.consumer_unit);
        // console.log(calc)
        return {
          value: calc.average,
          creditos: calc.creditos,
          pagamento: calc.mensalidade,
          pagamento_cemig:
            calc.average - calc.mensalidade - calc.economia_mensal,
          economia_mensal: calc.economia_mensal,
          economia_anual: calc.economia_anual,
        };
      } else {
        // console.log(this.lead.consumer_unit)
        let desconto = 0.1;
        if (this.lead.payment_type === "credit_card") desconto = 0.15;
        return {
          value: this.lead.average_consumption,
          creditos: Number(this.lead.average_consumption) * (1 - 0.09) - 50,
          pagamento:
            (this.lead.average_consumption * (1 - 0.09) - 50) * (1 - desconto),
          pagamento_cemig:
            this.lead.average_consumption * 1 -
            (this.lead.average_consumption * (1 - 0.09) - 50),
          economia_mensal:
            (this.lead.average_consumption * (1 - 0.09) - 50) * desconto,
          economia_anual:
            (this.lead.average_consumption * (1 - 0.09) - 50) * desconto * 12,
        };
      }
    },
  },
  filters: {
    formatDate(value) {
      if (!value) return "Não assinado!";
      const newDate = value.toDate();
      return moment(newDate).format("DD/MM/YYYY");
    },
    formatarMoeda: function (value) {
      if (!value) return "";
      return "R$ " + Number(value).toFixed(2).replace(".", ",");
    },
  },
};
</script>
